import type { Row } from "@tanstack/react-table";

import { Color } from "src/theme";
import { type ShipToListDto, CustomerStatusEnum } from "src/types";

export const overrideRowProps = (row: Row<ShipToListDto>): Record<string, unknown> => {
    if (row.original.status === CustomerStatusEnum.Blocked) {
        return { $backgroundColor: Color.neutral300 };
    }
    if (row.original.status === CustomerStatusEnum.Inactive) {
        return { $backgroundColor: Color.supportGraphite50 };
    }
    if (row.original.status === CustomerStatusEnum.New) {
        return { $backgroundColor: Color.accent100 };
    }
    return { $backgroundColor: Color.white };
};
